import { render } from "./KoruEditor.vue?vue&type=template&id=7aa466fd&ts=true"
import script from "./KoruEditor.vue?vue&type=script&lang=ts"
export * from "./KoruEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__